/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrortoomany4Inputs */

const en_menuscanerrortoomany4 = /** @type {(inputs: Menuscanerrortoomany4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At most 6 files and one PDF per reading.`)
};

const de_menuscanerrortoomany4 = /** @type {(inputs: Menuscanerrortoomany4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstens 6 Dateien und ein PDF pro Einlesen.`)
};

/**
* | output |
* | --- |
* | "At most 6 files and one PDF per reading." |
*
* @param {Menuscanerrortoomany4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrortoomany4 = /** @type {((inputs?: Menuscanerrortoomany4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrortoomany4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrortoomany4(inputs)
	return de_menuscanerrortoomany4(inputs)
});
export { menuscanerrortoomany4 as "menuScanErrorTooMany" }